<ng-container *ngIf="heatingSchedule$ | async | ready as heatingSchedule">
  <app-timemanager
    class="gap"
    (scheduleChange)="heatingPanelService.onScheduleChange($event, heatingSchedule)"
  ></app-timemanager>
  <div data-at-programs class="flex flex-row gap-[30px] justify-end">
    <vi-program-item
      *ngFor="let program of programs$ | async"
      program="{{ program.css }}"
      [hasTemperature]="false"
    >
      <vi-text name fxFlex class="capitalize">
        {{ program?.name | translateOperatingProgram }}
      </vi-text>
    </vi-program-item>
  </div>
  <div class="programs-container gap flex flex-row justify-between items-center">
    <button
      mat-stroked-button
      color="primary"
      gtm="onOpen"
      gtmAction="Multiple days selection dialog"
      gtmCategory="heatingSchedule"
      id="edit-multiple-dhw-btn-mfh"
      data-at-edit-multiple
      (click)="timemanagerDialogService.openSelectDaysDialog()"
    >
      {{ '+SCHEDULES.BUTTON.EDIT_MULTIPLE_DAYS' | translate }}
    </button>
    <div data-at-programs class="programs flex flex-row">
      <app-program-toggle-panel [circuitId]="circuitId"></app-program-toggle-panel>
    </div>
  </div>

  <app-banner
    *ngIf="
      (reducedCooling$ | async | ready) ||
      (normalCooling$ | async | ready) ||
      (comfortCooling$ | async | ready)
    "
    type="info"
  >
    {{
      ('+SCHEDULES.NOTICE.TITLE' | translate) +
        ': ' +
        ('+SCHEDULES.NOTICE.COOLING_INFO_TEXT' | translate)
    }}
  </app-banner>

  <div class="flex flex-col">
    <app-heating-temperature [circuitId]="circuitId"></app-heating-temperature>
    <app-cooling-temperature [circuitId]="circuitId"></app-cooling-temperature>
  </div>
</ng-container>
